export default __webpack_public_path__ + "static/media/simple-buying-img.09a9b829.svg";